import { useEffect, useRef } from "react";
import { IGif, IGifList } from "@/common/services/types";
import { filterGifsList } from "@/common/utils/filterGifsList";
import { useRecommendedFeedStore } from "@/common/store/recommendedFeedStore";

export const useFeedIdTrack = (data: IGifList) => {
  const setFeedId = useRecommendedFeedStore((state) => state.setFeedId);
  const setFeedGifsIds = useRecommendedFeedStore((state) => state.setFeedGifsIds);
  const reset = useRecommendedFeedStore((state) => state.reset);
  const currentGifs = useRef<IGif[]>([]);

  useEffect(() => {
    if (data?.gifs) {
      const filteredGifs = filterGifsList(currentGifs.current, data.gifs);
      currentGifs.current = filteredGifs;
      setFeedId(data?.feed_id || "");
      setFeedGifsIds(filteredGifs.map(g => g.id));
    }
  }, [data]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
};
